import { useOpenTaskCount } from './useTasksData';

/** Prototype #taskNavBadge (line 923) + updateTaskNavBadge (line 2321): open visible tasks, hidden at 0. */
export function TaskNavBadge() {
  const count = useOpenTaskCount();
  return (
    <span className={count > 0 ? 'task-nav-badge' : 'task-nav-badge hidden'} id="taskNavBadge">
      {count}
    </span>
  );
}
